module.exports = __webpack_public_path__ + "img/voice.0340bb13.png";